<template>
  <span
    v-b-tooltip.topleft.noninteractive="{
      title: `${tooltip_text ? tooltip_text : ''}`,
      boundary: 'viewport',
      variant: `${tooltip_variant}`,
    }"
  >
    <b-button
      size="sm"
      :variant="variant"
      :title="text_button"
      @click="handleClick"
      class="noprint p-0"
      :class="custom_class"
      :disabled="disabled_button"
    >
      <b-icon-plus-square v-if="icon == 'plus'"></b-icon-plus-square>
      <b-icon-pencil-square v-else-if="icon == 'square'"></b-icon-pencil-square>
      <b-icon-lock-fill v-else-if="icon == 'lock'"></b-icon-lock-fill>
      <b-icon-unlock-fill v-else-if="icon == 'unlock'"></b-icon-unlock-fill>
      <b-icon-trash
        v-else-if="icon == 'trash'"
        :variant="variant_icon"
      ></b-icon-trash>
      <b-icon-x-circle v-else-if="icon == 'x-circle'"></b-icon-x-circle>
      <!-- <b-icon-arrow-down-up v-else-if="icon == 'arrow-down-up'"></b-icon-arrow-down-up> -->
      <b-icon-eye v-else-if="icon == 'eye'"></b-icon-eye>
      <b-icon-eye-slash v-else-if="icon == 'eye-slash'"></b-icon-eye-slash>
      <b-icon-book v-else-if="icon == 'book'"></b-icon-book>
      <b-icon-eraser v-else-if="icon == 'clean'"></b-icon-eraser>
      <b-icon-files v-else-if="icon == 'files'"></b-icon-files>
      <b-icon-save v-else-if="icon == 'save'"></b-icon-save>
      <b-icon-brush v-else-if="icon == 'brush'"></b-icon-brush>
      <b-icon-card-heading
        v-else-if="icon == 'card-heading'"
      ></b-icon-card-heading>
      <b-icon-search v-else-if="icon == 'search'"></b-icon-search>
      <b-icon-filter-square
        v-else-if="icon == 'filter-square'"
      ></b-icon-filter-square>
      <b-icon-chevron-down
        v-else-if="icon == 'chevron-down'"
      ></b-icon-chevron-down>
      <b-icon-box-arrow-in-down
        v-else-if="icon == 'box-arrow-in-down'"
      ></b-icon-box-arrow-in-down>
      <b-icon-chevron-up v-else-if="icon == 'chevron-up'"></b-icon-chevron-up>
      <b-icon-arrow-counterclockwise
        v-else-if="icon == 'counterclockwise'"
      ></b-icon-arrow-counterclockwise>
      <b-icon-info-circle-fill
        v-else-if="icon == 'info'"
        variant="danger"
      ></b-icon-info-circle-fill>
      <slot name="icon"></slot>
      <span v-if="text_button" class="">
        {{ text_button }}
      </span>
    </b-button>
  </span>
</template>

<script>
export default {
  name: "ButtonSmall",
  props: {
    text_button: {
      type: String,
      required: false,
    },
    tooltip_text: {
      type: String,
      required: true,
    },
    click_button: {
      type: Function,
      required: false,
    },
    size: {
      type: String,
      default: "sm",
    },
    variant: {
      type: String,
      default: "none",
    },
    variant_icon: {
      type: String,
      default: "danger",
    },
    icon: {
      type: String,
      default: "",
      validator: (value) =>
        [
          "plus",
          "square",
          "trash",
          "x-circle",
          //   "arrow-down-up",
          "eye",
          "eye-slash",
          "book",
          "clean",
          "info",
          "lock",
          "unlock",
          "save",
          "card-heading",
          "files",
          "search",
          "filter-square",
          "chevron-down",
          "box-arrow-in-down",
          "brush",
          "chevron-up",
          "counterclockwise",
          "",
        ].includes(value),
    },
    tooltip_variant: {
      type: String,
      default: "secondary",
      validator: (value) =>
        [
          "primary",
          "secondary",
          "success",
          "danger",
          "warning",
          "info",
          "light",
          "dark",
        ].includes(value),
    },
    custom_class: {
      type: String,
      default: "",
    },
    disabled_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClick() {
      // Si se proporciona una función de click, se ejecuta
      if (!this.disabled_button) {
        if (this.click_button) {
          this.click_button();
        } else {
          this.$emit("click");
        }
      }
    },
  },
};
</script>

<style scoped>
button:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease-in-out;
}
button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: scale(1);
  transition: transform 0s ease-in-out;
}
</style>